import React, { useEffect, useState } from 'react'
import styles from './BillingPaymentData.module.css'
import Text from '../../../components/text/Text'
import arrowBack from '../../../assets/icons/icons-arrow-back.svg'
import noDataImage from '../../../assets/images/nodata.png'
import { useNavigate } from 'react-router-dom'
import routes from '../../../router/routes'
import SvgIcon from '../../../components/svgIcon/SvgIcon'
import { getInvoicePayData } from '../../../services/billing'
import { formatRut } from '../../../formatters'

export function BillingPaymentData() {
    const navigation = useNavigate()

    const [data, setData] = useState({
        rut: '',
        nombre: '',
        banco: '',
        n_cuenta: '',
        tipo_cuenta: '',
        rut_titular: '',
        nombre_titular: '',
        periocidad_pago: '',
        factura: '',
    })

    const handleGoBack = () => {
        navigation(`/${routes.billing}`)
    }

    useEffect(() => {
        getInvoicePayData().then((success) => {
            const _data = success.body.data
            setData({
                rut: formatRut(_data.rut),
                nombre: _data.razonSocial,
                banco: _data.banco,
                n_cuenta: _data.numCuenta,
                tipo_cuenta: _data.tipoCuenta,
                rut_titular: formatRut(_data.rutTitular),
                nombre_titular: _data.nombreTitular,
                periocidad_pago: _data.recurrenciaPago,
                factura: String(_data.poseeFactura) === 'true' ? 'Si' : 'No',
            })
        })
    }, [])

    const dataNoDisponible = () => {
        return (
            <div className={styles.noData}>
                <img src={noDataImage} style={{ width: '74.94px', marginBottom: '20px', marginLeft: '15px' }}/>
                <Text
                    fontSize={24}
                    color="#656565"
                    fontWeight={'bold'}
                    label="Datos no disponibles"
                />
            </div>
        )
    }

    if (!data.banco) return dataNoDisponible()

    return (
        <div className={styles.sectionFacturacionPaymentData}>
            <div className={styles.header}>
                <img
                    src={arrowBack}
                    onClick={handleGoBack}
                    className={styles.back}
                />
                <Text
                    fontSize={20}
                    marginLeft={15}
                    color="#656565"
                    fontWeight={600}
                    label="Datos de Pago"
                />
            </div>
            <div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsStore" />
                        </div>
                        <div>
                            <Text
                                label="Rut local"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.rut}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsIdCard" />
                        </div>
                        <div>
                            <Text
                                label="Razón Social Local"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.nombre}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsBuildings" />
                        </div>
                        <div>
                            <Text
                                label="Banco"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.banco}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsDetail" />
                        </div>
                        <div>
                            <Text
                                label="N° de cuenta"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.n_cuenta}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsColumns" />
                        </div>
                        <div>
                            <Text
                                label="Tipo de cuenta"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.tipo_cuenta}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsIdCard" />
                        </div>
                        <div>
                            <Text
                                label="Rut Titular"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.rut_titular}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsUser" />
                        </div>
                        <div>
                            <Text
                                label="Nombre de Titular"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.nombre_titular}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsCalendarCheck" />
                        </div>
                        <div>
                            <Text
                                label="Periodicidad del pago"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.periocidad_pago}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsTicket" />
                        </div>
                        <div>
                            <Text
                                label="Posee factura"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.factura}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
